import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  DialogRef,
  DialogService,
  DIALOG_DATA,
} from '@cyborg-monorepo/common/angular/cyborg-ui';
import { HuntPackageRecord, Profile } from '@cyborg-monorepo/hunter/common';
import { SupportService } from '../../../services/support.service';
import { UserService } from '../../../services/user.service';

@Component({ standalone: false, 
  selector: 'cyborg-modal-unlock',
  templateUrl: './unlock.component.html',
  styleUrls: ['./unlock.component.scss'],
})
export class UnlockModalComponent implements OnInit {
  public unlockForm: FormGroup;
  public email: string;
  public submitted: boolean = false;
  public error: string;

  constructor(
    private userService: UserService,
    public dialogRef: DialogRef,
    public dialog: DialogService,
    public supportService: SupportService,
    @Optional()
    @Inject(DIALOG_DATA)
    public data: { huntPackage: Partial<HuntPackageRecord> },
  ) {}

  public ngOnInit(): void {
    this.unlockForm = new FormGroup({
      message: new FormControl('', [Validators.required]),
    });

    this.userService.getProfile().subscribe((profile: Profile) => {
      this.email = profile.email;
    });
  }

  public onClose(): void {
    this.dialogRef.close();
  }

  public onUnlock(): void {
    this.supportService
      .sendUnlockEmail({
        message: this.unlockForm.value.message,
        requestedContent: this.data.huntPackage.title,
        contentUrl:
          window.location.origin +
          '/research/hunt-package/' +
          this.data.huntPackage.UUID,
      })
      .subscribe(
        () => {
          this.submitted = true;
          this.unlockForm.patchValue({
            message: '',
          });
        },
        (error) => {
          this.error = error.message;
        },
      );
  }
}
